"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextAsyncIterator = void 0;
async function getNextAsyncIterator(asyncIterator, index) {
    return {
        index,
        result: await asyncIterator.next(),
    };
}
exports.getNextAsyncIterator = getNextAsyncIterator;
